var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggle",on:{"click":_vm.onClick}},[(_vm.show)?_c('span',[_vm._v(_vm._s(_vm.hideText)),_c('KIcon',{attrs:{"icon":"dropup"}})],1):_c('span',[_vm._v(_vm._s(_vm.showText)),_c('KIcon',{attrs:{"icon":"dropdown"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }